import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {_AQH_EVE_25, AQH_EVE_28} from '../../../../../../../../../../@shared/models/input.module';
import {EventContactRoleResponse, EventResponse, UserSearchResult} from '../../../../../../../../../../@shared/models/response.module';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-add-contact',
  standalone: false,
  templateUrl: './add-contact.html',
  styleUrl: './add-contact.css'
})
export class AddContact {
  @Input() event: EventResponse

  first_name = '';
  last_name = '';
  phone = '';
  email = '';
  role_id: number | null = null;

  // User search
  userSearch = '';
  userSearchResults: UserSearchResult[] = [];
  selectedUser: UserSearchResult | null = null;
  isSearching = false;
  showResults = false;
  private searchSubject = new Subject<string>();

  roles: EventContactRoleResponse[] = [];
  loadingRoles: boolean = false;
  submitted: boolean = false;
  saving: boolean = false;

  constructor(private eventsService: EventsService,
              private modal: NgbActiveModal,
              private toastService: ToastService,
              private translateService: TranslateService) {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(search => {
      this.performSearch(search);
    });
  }

  ngOnInit() {
    this.loadRoles();
  }

  loadRoles() {
    this.loadingRoles = true;
    let payload: AQH_EVE_28 = {};
    this.eventsService.getEventContactRoles(payload).subscribe({
      next: (res: EventContactRoleResponse[]) => {
        this.roles = res;
        this.loadingRoles = false;
      },
      error: () => {
        this.loadingRoles = false;
        this.roles = [];
      }
    });
  }

  onSearchInput(value: string) {
    this.userSearch = value;
    if (value.length >= 2) {
      this.searchSubject.next(value);
    } else {
      this.userSearchResults = [];
      this.showResults = false;
    }
  }

  performSearch(search: string) {
    if (search.length < 2) return;
    console.log('Performing search for:', search);
    this.isSearching = true;
    this.eventsService.searchUsers(search).subscribe({
      next: (res: UserSearchResult[]) => {
        console.log('Search results:', res);
        this.userSearchResults = res;
        this.showResults = true;
        this.isSearching = false;
      },
      error: (err) => {
        console.error('Search error:', err);
        this.userSearchResults = [];
        this.isSearching = false;
        this.showResults = false;
      }
    });
  }

  selectUser(user: UserSearchResult) {
    this.selectedUser = user;
    this.first_name = user.first_name;
    this.last_name = user.last_name;
    this.email = user.email || '';
    this.phone = user.phone || '';
    this.userSearch = user.full_name;
    this.showResults = false;
  }

  clearSelectedUser() {
    this.selectedUser = null;
    this.userSearch = '';
    this.first_name = '';
    this.last_name = '';
    this.email = '';
    this.phone = '';
  }

  // Validation helpers
  get isFirstNameInvalid(): boolean {
    return this.submitted && !this.first_name.trim();
  }

  get isLastNameInvalid(): boolean {
    return this.submitted && !this.last_name.trim();
  }

  get isRoleInvalid(): boolean {
    return this.submitted && this.role_id == null;
  }

  get isFormValid(): boolean {
    return !!(this.first_name.trim() && this.last_name.trim() && this.role_id != null);
  }

  onSave() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('manageEvent.addContact.validationError'));
      return;
    }

    this.saving = true;

    const payload: _AQH_EVE_25 = {
      event_id: this.event.event_id,
      user_id: this.selectedUser?.user_id,
      first_name: this.first_name.trim(),
      last_name: this.last_name.trim(),
      phone: this.phone.trim(),
      email: this.email.trim(),
      role_id: this.role_id!
    };

    this.eventsService.addEventContact(payload).subscribe({
      next: (res: any) => {
        this.saving = false;
        this.toastService.success(this.translateService.instant('manageEvent.addContact.success'));
        this.modal.close(res.data);
      },
      error: (err) => {
        this.saving = false;
        this.toastService.error(err.error?.reason || this.translateService.instant('manageEvent.addContact.error'));
      }
    });
  }

  close() {
    this.modal.close();
  }
}
